import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/pp-vue-library'
import PpVueAnalytics from 'pp-vue-analytics'
import { datadogRum } from '@datadog/browser-rum'
import { Resizer } from 'sdk-widget-manager'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { RECAPTCHA_SITE_KEY, GA4_PREFIX, GA_ID, GA4_ID } from '@/constants'
import trackGA from '@/mixins/track-ga'

Vue.use(Resizer)
Vue.config.productionTip = false

const params = new URLSearchParams(window.location.search)

const practiceGaId = params.get('gaId')
const isGA4Enabled = practiceGaId ? practiceGaId.includes(GA4_PREFIX) : false
const appGaId = isGA4Enabled ? GA4_ID : GA_ID

Vue.use(PpVueAnalytics, router, {
  appGaId,
  practiceGaId,
  category: 'webtotext',
  trackEventPrefix: isGA4Enabled ? 'web_to_text' : '',
  practiceUuid: params.get('practiceUuid')
})
Vue.mixin(trackGA)

Vue.use(VueReCaptcha, { siteKey: RECAPTCHA_SITE_KEY })

Vue.prototype.$isGA4Enabled = isGA4Enabled
Vue.prototype.$ppUi = {
  isMobile: false
}
Vue.prototype.$vuetify = {
  rtl: false,
  lang: {
    t: (val) => val
  },
  theme: {
    dark: false
  },
  breakpoint: {
    mobile: true,
    mobileBreakpoint: 600
  },
  icons: {
    values: {
      prev: 'mdi-chevron-left',
      next: 'mdi-chevron-right',
      dropdown: 'mdi-chevron-down',
      first: 'mdi-page-first',
      last: 'mdi-page-last',
      unfold: 'mdi-unfold-more-horizontal'
    }
  }
}

Vue.prototype.$isMultiChannelEnabled = params.get('isMultiChannelEnabled')
Vue.prototype.$practiceUuid = params.get('practiceUuid')
Vue.prototype.$ppColors = {
  primary: params.get('color_palette[primary]') ? params.get('color_palette[primary]').replace('#', '') : null,
  secondary: params.get('color_palette[secondary]') ? params.get('color_palette[secondary]').replace('#', '') : null,
  accent: params.get('color_palette[accent]') ? params.get('color_palette[accent]').replace('#', '') : null
}
Vue.prototype.$practiceDomain = params.get('domain')
Vue.prototype.$originHost = params.get('originHost')

datadogRum.init({
  applicationId: '1889cd57-7953-4589-9271-ddc52ed85235',
  clientToken: 'pubae32e7f7f2cd9c7e24c1bec5813932e5',
  env: process.env.VUE_APP_STAGE,
  version: process.env.VUE_APP_VERSION,
  sampleRate: 50,
  site: 'datadoghq.com',
  service: 'widget-webtotext',
  useCrossSiteSessionCookie: true,
  trackInteractions: true,
  trackFrustrations: true,
  beforeSend: (event, context) => {
    // collect a RUM resource's response headers
    if (event.type === 'resource' && event.resource.type === 'fetch') {
      event.context = { ...event.context, responseHeaders: context.response.headers }
    }
  }
})

datadogRum.addRumGlobalContext('practiceUuid', params.get('practiceUuid'))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
